const urls = {
    basename: process.env.NODE_ENV === 'development' ? '/media/wellfinderui' : '/wells'
}

const constructDetailUrl = (apiNumber) => {
    return `${urls.basename}/${apiNumber}`
}
export default urls
export { constructDetailUrl }